import banner_pdp_disney_plus from '@/assets/banner-pagina-produto-disney-plus.png';
import banner_pdp_hbo_max from '@/assets/banner-pagina-produto-hbo-max.jpg';
import banner_pdp_imovision from '@/assets/banner-pagina-produto-imovision.webp';
import { disneyPlusTermosHTML } from './disneyPlusHTML';

const mock = [
  {
    slug: 'disney-plus',
    'imagemDestaque.0.imagemUrl': banner_pdp_disney_plus,
    termosDeUso: disneyPlusTermosHTML,
  },
  {
    slug: 'hbo-max',
    'imagemDestaque.0.imagemUrl': banner_pdp_hbo_max,
  },
  {
    slug: 'imovision-1',
    'imagemDestaque.0.imagemUrl': banner_pdp_imovision,
  },
];

export default mock;
